import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import { DeparturePicker } from '../components/departure-picker.js';

$(() => {
    detailsPackage.init();
});

const detailsPackage = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: null,
        time: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');
        this.params.dynamicPackage = +this.$booking.attr('data-dynamicpackage'); 

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && [1,2].includes(this.params.dynamicPackage) && this.$booking.attr('data-flightapi') == 0)) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.referenceId = this.$booking.attr('data-referenceid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;
        this.allowedServices = $('[data-allowedservices]').attr('data-allowedservices');
        this.allowedServices = this.allowedServices ? JSON.parse(this.allowedServices) : [];
        this.params.isTravelgate = $('[data-isTravelgate]').attr('data-istravelgate');

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        //this.getCalculation();
        
        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            //this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        // check availability on form change (not only on btn click)
        /*$('[name="dates"], [name="guests"]').on('change', () => {
            const data = functions.getFormData(this.$form);
            if (data.dates && data.guests) {
                this.$form.trigger('submit');
            }
        });*/

        this.prepareAvailabilityForm();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $(window).on('hashchange', e => {
            this.getParams();
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.showTransportTicket();

            this.getCalculation(this.params);
        });

        if(this.$cart.length) {
            const $btnBooking = $('.btn-booking');

            $btnBooking.on('click', e => {
                e.preventDefault();
                let cartData = [];

                detailsPackage.cart.cartItems.forEach(item => {
                    item = JSON.parse(item);
                    cartData.push({
                        'unitId': item.unitId,
                        'dateFrom': item.dateFrom,
                        'dateTo': item.dateTo,
                        'aDateFrom': item.aDateFrom,
                        'aDateTo': item.aDateTo,
                        'guests': item.guests,
                        'flightUnitId': item.transportUnitId,
                        'placeFromId': item.placeFromId,
                        'time': item.time,
                        'serviceCode': item.serviceCode,
                        'serviceId': item.serviceId,
                        'pricelistId': detailsPackage.params.pricelistId,
                        'dynamicPackage': detailsPackage.params.dynamicPackage
                    });
                });

                if(detailsPackage.cart.cartItems.length) {
                    location = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=' + detailsPackage.params.dynamicPackage;
                } else {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }
        else {
            $(document).on('click', '.unit .btn-book-one-unit', e => {

                e.preventDefault();
                const $btnBooking = $(e.currentTarget);

                if (! detailsPackage.params.dateFrom || ! detailsPackage.params.dateTo || ! detailsPackage.params.guests) {
                    window.setAlertBooking($btnBooking);
                    return;
                }

                const unitId = $btnBooking.attr('data-unitid');

                let cartData = {
                    'unitId': unitId,
                    'dateFrom': detailsPackage.params.dateFrom,
                    'dateTo': detailsPackage.params.dateTo,
                    'aDateFrom': detailsPackage.params.aDateFrom,
                    'aDateTo': detailsPackage.params.aDateTo,
                    'time': detailsPackage.params.time,
                    'guests': detailsPackage.params.guests,
                    'flightUnitId': detailsPackage.params.transportUnitId,
                    'placeFromId': detailsPackage.params.placeFromId,
                    'pricelistId': $btnBooking.attr('data-pricelistid'),
                    'serviceCode': $btnBooking.attr('data-servicecode') ? encodeURIComponent($btnBooking.attr('data-servicecode')) : null,
                    'serviceId': $btnBooking.attr('data-serviceid'),
                    'dynamicPackage': detailsPackage.params.dynamicPackage
                };

                let extras = $btnBooking.attr('data-extra');
                if (extras) {
                    extras = JSON.parse(extras);

                    Object.keys(extras).forEach(function(key) {
                        let val = extras[key];
                        if (key === 'optionRefId' || key === 'remoteUnitId') {
                            val = encodeURIComponent(val);
                        } else if (key === 'cancellationPolicy') {
                            return;
                        }
                        cartData[key] = val;
                    });
                }

                location = $(e.currentTarget).attr('data-href') + '?dynamicPackage='+detailsPackage.params.dynamicPackage+'&cart_data=' + JSON.stringify([cartData]);
            });

        }

        $(document).on('change', '.block-totals-per-service [type="radio"]', e => {

            const $unit = $(e.currentTarget).closest('.unit');
            const $addToCart = $unit.find('.add-to-cart');
            const $btnBooking = $unit.find('.btn-book-one-unit');
            const $radioService = $unit.find('[type="radio"]:checked');
            const $totalPerService = $radioService.closest('.total-per-service');

            let total = $totalPerService.find('[data-totalperservice]').attr('data-totalperservice');
            let totalOld = $totalPerService.find('[data-oldtotalperservice]').attr('data-oldtotalperservice');
            let currency = $totalPerService.find('[data-currency]').attr('data-currency');
            let bookingStatus = $totalPerService.find('[data-bookingstatus]').attr('data-bookingstatus');
            let pricelistid = $totalPerService.find('[data-pricelistid]').attr('data-pricelistid');
            let serviceId = $radioService.attr('data-serviceval');
            let serviceKey = $radioService.attr('data-servicekey');
            let extras = $radioService.attr('data-extra');

            if ($addToCart.length) {
                $addToCart.attr('data-' + serviceKey, serviceId);
                $addToCart.attr('data-unitcarttotal', total);
                $addToCart.attr('data-unitcarttotalold', totalOld);
                $addToCart.attr('data-currencysymbol', currency);

                $addToCart.attr('data-datefrom', detailsPackage.params.dateFrom);
                $addToCart.attr('data-dateto', detailsPackage.params.dateTo);
                $addToCart.attr('data-guests', detailsPackage.params.guests);

                $addToCart.attr('data-adatefrom', detailsPackage.params.aDateFrom);
                $addToCart.attr('data-adateto',detailsPackage. params.aDateTo);

                $addToCart.attr('data-transportunitid', detailsPackage.params.transportUnitId);
                $addToCart.attr('data-placefromid', detailsPackage.params.placeFromId);
                $addToCart.attr('data-time', detailsPackage.params.time);

            } else {
                $btnBooking.attr('data-' + serviceKey, serviceId);
                $btnBooking.attr('data-pricelistid', pricelistid);
                $btnBooking.attr('data-extra', extras);

                if (extras) {
                    extras = JSON.parse(extras);
                    const unitId = $unit.attr('data-unitid');
                    let $cp = '<div>Za odabrani termin nije moguć povraćaj novca u slučaju otkazivanja.</div>';

                    if (this.params.isTravelgate && extras.cancellationPolicy && extras.cancellationPolicy.length) {

                        $cp = '<div>';
                        $cp += 'Možete besplatno otkazati rezervaciju do <strong>' + functions.decreaseDate(extras.cancellationPolicy[0].deadline, 1) + '</strong><br>';

                        extras.cancellationPolicy.forEach((item, key) => {
                            if (item.penaltyType === 'IMPORT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + functions.formatMoney(item.value, 2, ',', '') +' '+ item.currency + '</strong>.<br>';
                            }
                            else if (item.penaltyType === 'PERCENT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + item.value + '%</strong>.<br>';
                            }
                            else if (item.penaltyType === 'NIGHTS') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naplaćuje se naknada u iznosu  <strong> ' + item.value + 'noćenja</strong>.<br>';
                            }
                        });
                        $cp += '</div>';
                    }

                    const board = $(e.currentTarget).closest('.form-check').find('.form-check-label').text() ? $(e.currentTarget).closest('.form-check').find('.form-check-label').text() : $unit.find(".service-label").text();
                    const $unitModal =  $("#unitModal-" + unitId);

                    $unitModal.find("#cancellationPolicy-" + unitId).html($cp);
                    $unitModal.find('.modal-service-name').html(board);
                }

                $btnBooking.text(bookingStatus === 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));
            }
        });
    },
    prepareAvailabilityForm() {
        $('.tickets').append('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>');
        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: this.params.dynamicPackage,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
            placeFromId: this.params.placeFromId,
        }).always(response => {
            response = response ? JSON.parse(response) : null;

            if (response.status) {
                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                this.departurePoints = response.data.departurePoints;
                const serviceCodes = response.data.serviceCodes;
                //const $nights = $("[name='nights']");

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = prepared.prices;

                const $service = $("[name='serviceCode']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                if (serviceCodes.length) {
                    $serviceWrapper.removeClass('d-none')
                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key === serviceCode) {
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });
                } else {
                    $serviceWrapper.addClass('d-none');
                }

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => {
                    return a - b
                });

                if (nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text: night})

                        if (!this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    /*$nights.select2({
                        data: _nights,
                        minimumResultsForSearch: -1
                    });*/

                    //setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }

                const $detailsDatepicker = $("#details-datepicker");
                $detailsDatepicker.attr('data-departures', JSON.stringify(this.enable));
                $detailsDatepicker.attr('data-flights', JSON.stringify(this.flights));
                $detailsDatepicker.attr('data-prices', JSON.stringify(this.prices));
                $detailsDatepicker.attr('data-departurePoints', JSON.stringify(this.departurePoints));

                $detailsDatepicker.find('[data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });

                this.setDefaultDeparture();
                functions.setFormData(this.form, this.params);

                // showFlightTickets must MANDATORY be after setFormData
                this.params.dateFrom && this.showTransportTicket();
                //this.params.dynamicPackage == 2 && this.setDeparturePoints();
                this.setDeparturePoints();

                this.getCalculation();

                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);

                    this.params.dateFrom = data.dateFrom;
                    this.params.dateTo = data.dateTo;
                    this.params.guests = data.guests;
                    this.params.time = data.time;
                    this.params.duration = data.duration;
                    this.params.transportUnitId = data.transportUnitId;
                    this.params.placeFromId = data.placeFromId;

                    functions.setUrlData(
                        {
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'guests': this.params.guests,
                            'time': this.params.time,
                            'duration': this.params.duration,
                            'transportUnitId': this.params.transportUnitId,
                            'placeFromId': this.params.placeFromId,
                        },
                        true,
                        true);
                });

                $(document).on('click', '.ticket', e => {
                    this.setTransportTicket($(e.currentTarget), true);
                });

                let travelProgramIds = [];
                response.data.flights.forEach((flight) => {
                    if (flight.travelProgramId ) {
                        travelProgramIds.push(flight.travelProgramId);
                    }
                });

                this.getTravelProgram(travelProgramIds);

            }
        });
    },
    getTravelProgram(travelProgramIds) {
        let programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;

        if(programURL && travelProgramIds.length) {
            programURL += '?publicIds=' + travelProgramIds.join(',') + '&language=' + functions.getLang();
            $.get(programURL).done(response => {
                response = JSON.parse(response);
                if (response.status) {
                    this.travelProgram = response.html;
                    this.showTravelProgram();
                } else {
                    $('.travel-program-link').addClass('d-none');
                }
            }).fail(e => {
                $('.travel-program-link').addClass('d-none');
            });
        }
    },
    showTravelProgram() {
        const $ticket = $('.ticket.active');
        const travelProgramId = JSON.parse($ticket.attr('data-travelprogramid'));
        const $modal = $('#travelProgramModal');

        let $travelProgram = $(this.travelProgram).find('#travelProgram' + travelProgramId);
        let html = $travelProgram.html();
        $modal.find('.modal-body').html(html);
        $modal.find('.btn-print').attr('data-params', $travelProgram.attr('data-print'));

        $('.travel-program-link').removeClass('d-none');
    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            // let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            //let unique = rate.aDateFrom + ',' + rate.aDateTo + ',' + rate.dateFrom + ',' + rate.dateTo;
            let unique = rate.dateFrom + ',' + rate.dateTo;
            
            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;

            if ( flight.timeDepartureFrom ) {
                flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
            }

            let flightUnique = flightUnitId + (flight.time ? '_' + flight.time : '');

            if ( ! departures[unique]) {
                let flights = {};
                flights[flightUnique] = flight;

                let rates = {};
                rates[rate.id] = rate;

                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flights'       : flights,
                    'rates'         : rates,
                };
            } else {
                let departure = departures[unique];
                departure.flights[flightUnique] = flight;
                departure.rates[rate.id] = rate;
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                aDateFrom: rate['aDateFrom'],
                aDateTo: rate['aDateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
            });

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let departureDay = detailsPackage.getWeekDay(arrival);
            let returnArrivalDay = detailsPackage.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromId = flight['placeFromId'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                let flightSmallImg;
                let travelProgramId;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                        flightSmallImg = ft.images.small ? ft.images.small : '';
                        travelProgramId = ft.travelProgramId;
                    }
                });

                let arrivalDay = detailsPackage.getWeekDay(arrivalDate);
                let returnDepartureDay = detailsPackage.getWeekDay(returnDate);
                
                flights.push({
                    duration              : rate.duration,
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightSmallImg        : flightSmallImg,
                    travelProgramId       : travelProgramId,
                    flightUnitId          : flight.unitId,
                    departureDay          : departureDay,
                    returnDepartureDay    : returnDepartureDay,
                    arrivalDay            : arrivalDay,
                    returnArrivalDay      : returnArrivalDay,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromId           : placeFromId,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    getDeparturePoints (params) {
        return $.post('/services/departure_points/', { dynamicPackage: params.dynamicPackage, objectId: params.objectId });
    },
    setDeparturePoints () {
        const $placeFromId = $('[name="placeFromId"]');
        $placeFromId.empty();

        this.departurePoints && this.departurePoints.forEach(departurePoints => {
            const newOption = new Option(departurePoints.placeName, departurePoints.placeId, false, this.params.placeFromId == departurePoints.placeId);
            $placeFromId.append(newOption);
        });

        /*this.getDeparturePoints({
            dynamicPackage: this.params.dynamicPackage,
            objectId: this.params.referenceId
        }).then(response => {
            departurePoints = response;
            
            departurePoints.forEach(departurePoints => {
                const newOption = new Option(departurePoints.name, departurePoints.id, false, this.params.placeFromId == departurePoints.id);
                $placeFromId.append(newOption);
            });
        });*/

        //$placeFromId.val(this.params.placeFromId).trigger('change');
    },
    showPlacesFrom (tickets) {
        $('.tickets').addClass('show-active');
        //const $transportUnitId = $('[name="transportUnitId"]');
        //$transportUnitId.empty();

        /*tickets.forEach(ticket => {
            const newOption = new Option(ticket.placeFromName, ticket.flightUnitId, false, false);
            $transportUnitId.append(newOption);
        });*/

        //$transportUnitId.val(this.params.transportUnitId);
    },
    showTransportTicket(){
        const dataTransport = JSON.parse($('[data-flights]').attr('data-flights'));

        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let duration = this.params.duration;
        let time = this.params.time != ' ' && (this.params.time && ! this.params.time.startsWith('null')) ? this.params.time : null;
        time = time == 'undefined' ? null : time;

        if (duration) {
            if (! $('.duration-item[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"][data-duration="' + duration + '"]').length) {
                duration = this.params.duration = null;
            }
        }

        if (! duration && $('.duration-item.active').length) {
            duration && $('.duration-item.active').attr('data-duration');
        }

        let tickets = dataTransport.filter(ticket => {
            return ticket.dateFrom == dateFrom 
                && ticket.dateTo == dateTo 
                && (duration ? ticket.duration == duration : true)
                //&& (time && ticket.time ? ticket.time == time : true);
        });

        tickets.sort((a, b) => {
            return a.duration - b.duration;
        });

        //this.params.dynamicPackage == 2 && this.showPlacesFrom(tickets);
        this.showPlacesFrom(tickets);
        
        this.renderTransportTickets(tickets);
    },
    renderTransportTickets(tickets) {
        const $tickets = $('.tickets').empty();

        const isFlight = this.params.dynamicPackage == 1;

        let hasActiveTicket = tickets.find((ticket) => {
            return ticket.flightUnitId == this.params.transportUnitId;
        });

        tickets.forEach((ticket, index) => {
            const time = ticket.timeDepartureFrom && ticket.timeReturnFrom ? ticket.timeDepartureFrom + ',' + ticket.timeReturnFrom : null;
            this.params.time = ! this.params.time && index == 0 ? time : this.params.time;

            if (ticket.flightTitle == 'Arena Travel d.o.o.') {
                ticket.flightTitle = null;
            }

            if ( ! hasActiveTicket && index == 0) {
                this.params.transportUnitId = ticket.flightUnitId;
            }

            if (! ticket.flightSmallImg) {
                ticket.flightSmallImg = isFlight 
                ? '/wp-content/uploads/avio-aranzmani.jpg'
                : '/wp-content/uploads/bus-aranzmani.jpg';
            }

            $tickets.append(`
                <div class="ticket ${ isFlight ? 'ticket-flight' : 'ticket-bus'}"
                    data-aDateFrom="${ ticket.aDateFrom }"
                    data-aDateTo="${ ticket.aDateTo }"
                    data-transportUnitId="${ ticket.flightUnitId }"
                    data-time="${ ticket.time }"
                    data-placeFromId="${ ticket.placeFromId }"
                    data-travelProgramId="${ ticket.travelProgramId }">

                    <div class="row g-0">
                        ${ ticket.flightSmallImg ? `
                            <div class="col-lg-2">
                                <div class="ticket-img">
                                    ${ ticket.flightTitle ? `<div class="ticket-label">${ ticket.flightTitle }</div>` : '' }
                                    <img class="ozad" src=${ ticket.flightSmallImg }>
                                </div>
                            </div>
                        ` : '' }
                        <div class="col-lg">
                            <div class="ticket-departure">
                                <div class="row">
                                    <div class="col-12 col-xl-auto">
                                        <div class="ticket-placeFrom"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            ${ ticket.placeFromName }
                                        </div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.dateFrom) }</div>
                                        <div class="small">${ ticket.departureDay }${ ticket.timeDepartureFrom ? ' ' + ticket.timeDepartureFrom + ' h' : '' }</div>
                                    </div>
                                    <div class="col d-flex justify-content-between align-items-center">
                                        <hr />
                                        <div class="d-flex flex-column align-items-center text-center${ ticket.departureDuration ? '  mt-3 mt-lg-4 mb-3 mb-lg-0' : '' }">
                                            <i class="fa-solid ${ isFlight ? 'fa-plane' : 'fa-bus-side' }"></i>
                                            ${ ticket.departureDuration ? `<span class="small"><small>${ ticket.departureDuration } h</small></span>` : '' }
                                        </div>
                                        <hr />
                                    </div>
                                    <div class="col-12 col-xl-auto">
                                        <div class="ticket-placeTo"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            ${ ticket.placeToName }
                                        </div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.arrivalDate) }</div>
                                        <div class="small">${ ticket.arrivalDay }${ ticket.timeDepartureTo ? ' ' + ticket.timeDepartureTo + ' h' : '' }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg">
                            <div class="ticket-return">
                                <div class="row">
                                    <div class="col-12 col-xl-auto">
                                        <div class="ticket-placeTo"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            ${ ticket.placeToName }
                                        </div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.returnDate) }</div>
                                        <div class="small">${ ticket.returnDepartureDay }${ ticket.timeReturnFrom ? ' ' + ticket.timeReturnFrom + ' h' : '' }</div>
                                    </div>
                                    <div class="col d-flex justify-content-between align-items-center">
                                        <hr />
                                        <div class="d-flex flex-column align-items-center text-center${ ticket.returnDuration ? ' mt-3 mt-lg-4 mb-3 mb-lg-0' : '' }">
                                            <i class="fa-solid ${ isFlight ? 'fa-plane' : 'fa-bus-side' }"></i>
                                            ${ ticket.returnDuration ? `<span class="small"><small>${ ticket.returnDuration } h</small></span>` : '' }
                                        </div>
                                        <hr />
                                    </div>
                                    <div class="col-12 col-xl-auto">
                                        <div class="ticket-placeFrom"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            ${ ticket.placeFromName }
                                            </div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.dateTo) }</div>
                                        <div class="small">${ ticket.returnArrivalDay }${ ticket.timeReturnTo ? ' ' + ticket.timeReturnTo + ' h' : '' }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ticket-tail">
                        <div class="ticket-tail-check">
                            <i class="fa-light fa-check"></i>
                            <div class="label-selected"
                                data-labelSelected="Odabrano"
                                data-labelSelect="Odaberi">
                                Odaberi
                            </div>
                        </div>
                    </div>
                    
                </div>    
            `);

            //this.params.aDateFrom = $('.ticket.active').attr('data-adatefrom');
            //this.params.aDateTo = $('.ticket.active').attr('data-adateto');
        });

        let $ticket = $('.ticket[data-transportUnitId="' +  this.params.transportUnitId + '"]').first();

        if (this.params.placeFromId) {
            const $placeTicket = $('.ticket[data-placefromid="' +  this.params.placeFromId + '"]');
            if ($placeTicket.length) $ticket = $placeTicket;
        }

        //const $ticket = $('.ticket[data-transportUnitId="' +  this.params.transportUnitId + '"]');//.first();
        $ticket.length && this.setTransportTicket($ticket);
    },
    setTransportTicket($ticket, triggerChange = false) {
        $('.ticket').removeClass('active');

        const $prevLabelSelected = $('.ticket').find('.label-selected');
        $prevLabelSelected.text($prevLabelSelected.attr('data-labelSelect'));

        $ticket.addClass('active');
        const $labelSelected = $ticket.find('.label-selected');
        $labelSelected.text($labelSelected.attr('data-labelSelected'));

        this.getParams();
        let time = $ticket.attr('data-time');
        let aDateFrom = $ticket.attr('data-adatefrom');
        let aDateTo = $ticket.attr('data-adateto');
        let unitId = $ticket.attr('data-transportunitid');

        const $placeFromId = $('[name="placeFromId"]');

        setTimeout(() => {
            if ($ticket.hasClass('active') && $placeFromId.length && $placeFromId.val()) {
                const placeFrom = $placeFromId.parents('.form-floating').find('.select2-selection__rendered').text();
                $ticket.find('.ticket-placeFrom').text(placeFrom);
            }
        });

        //$('[name="time"]').val(time);
        //$('[name="aDateFrom"]').val(aDateFrom);
        //$('[name="aDateTo"]').val(aDateTo);

        this.params.time = time;
        this.params.aDateFrom = aDateFrom;
        this.params.aDateTo = aDateTo;
        this.params.transportUnitId = unitId;

        triggerChange && this.$form.change();
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        ! this.params.time && departure && (this.params.time = departure.time);
        
        departure = departure || this.departures[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time]
        this.params.aDateFrom = departure && departure.aDateFrom ? departure.aDateFrom : null;
        this.params.aDateTo = departure && departure.aDateTo ? departure.aDateTo : null;
        this.params.transportUnitId = departure && departure.flightUnitId ? departure.flightUnitId : null;
        
        //this.params.dateFrom = ! this.params.dateFrom && departures.length ? departures[0].dateFrom : this.params.dateFrom;
        //this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && departures.length ? departures[0].dateTo : this.params.dateTo;
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        cParams.calcPerService = 1;
        const calculation = details.getCalculation(cParams);

        if (this.params.isTravelgate) {
            $(".units-no-result-msg").addClass('d-none');
            $(".unit").addClass('d-none');
        }

        if(calculation) {

            if (this.params.isTravelgate) {
                $('.units-spinner').removeClass('d-none');
            } else {
                details.unitsSpinner();
            }


            //$('.rate-container').addClass('d-none');

            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                    if (this.params.isTravelgate) {
                        $('.units-spinner').addClass('d-none');
                    }
                }).fail(error => {
                    console.log(error);
                });

            return;

        }

        $('.rate-container').removeClass('d-none');
        $('.block-totals-per-service').addClass('d-none');
        $('.unit-error-message').addClass('d-none');
    },
    preparePriceAndBooking(unitId, $unit, unitData, params) {

        const $totalPerServiceBlock = $unit.find('.totals-per-service');
        const totalPerServiceHtml = $totalPerServiceBlock.html();

        let discountTitle;
        $totalPerServiceBlock.html('');

        const unitServices = Object.keys(unitData.services);
        const unitServiceCount = unitServices.length;

        unitServices.forEach(( serviceId) => {

            const dataPerService = unitData.services[serviceId];
            
            const unitCalc = dataPerService.calc;
            const currencySymbol = unitCalc.currencySymbol;
            const bookingStatus = dataPerService.booking.status;
            const unitCalcItems = unitCalc.items;
            const total = +unitCalc.total.toFixed(2);
            const pricelistid = unitCalc.items[0].pricelistId;

            const $totalPerServiceHtml = $(totalPerServiceHtml);

            let priceOld = details.getCalcTotalOld(unitCalcItems);
            priceOld = +priceOld.toFixed(2);

            let serviceText = '';
            if (dataPerService.customServiceName) {
                serviceText = dataPerService.customServiceName;
            } else {
                detailsPackage.allowedServices.forEach((allowedService) => {
                    if (dataPerService.serviceId && +allowedService.id === +dataPerService.serviceId ||
                        dataPerService.serviceCode && allowedService.key === dataPerService.serviceCode){
                        serviceText = allowedService.text;
                    }
                });

                if ( ! serviceText)
                {
                    if (dataPerService.serviceName) {
                        serviceText = dataPerService.serviceName;
                    }
                }
            }

            let totalRounded = functions.formatMoney(total, 0, '', '');
            $totalPerServiceHtml.attr('style', 'order:' + totalRounded);
            $totalPerServiceHtml.addClass('order-' + totalRounded);
            $totalPerServiceHtml.attr('data-order' , totalRounded);

            const $radio = $totalPerServiceHtml.find('[type="radio"]');

            const radioVal = serviceId;
            $radio.val(radioVal);
            $radio.attr('name', 'service-' + unitId);
            $radio.attr('id', 'service-' + unitId + '-' + radioVal);
            $radio.attr('data-servicekey', dataPerService.serviceCode ? 'serviceCode' : 'serviceId');
            $radio.attr('data-serviceval', dataPerService.serviceId || dataPerService.serviceCode);

            let extra = {};
            if (dataPerService.optionRefId) {
                extra.optionRefId = dataPerService.optionRefId;
            }

            if (unitData.unitName) {
                extra.unitName = unitData.unitName;
            }

            if (unitData.remoteUnitId) {
                extra.remoteUnitId = unitData.remoteUnitId;
            }

            if (dataPerService.cancellationPolicy) {
                extra.cancellationPolicy = dataPerService.cancellationPolicy;
            }

            $radio.attr('data-extra', JSON.stringify(extra));

            const $label = unitServiceCount > 1 ? $totalPerServiceHtml.find('label') : $unit.find('.service-label');

            if (dataPerService.tag) {
                serviceText += '<span class="ms-2 badge text-bg-primary-lt">'+(dataPerService.tag === 'nonref' ? 'non refundable' : 'refundable')+'</span>';
            }

            $label.text(serviceText);
            $label.attr('for', 'service-' + unitId + '-' + radioVal);

            const $oldTotal = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-oldtotalperservice]') : $unit.find('.price-old');
            $oldTotal.text(priceOld.toFixed(0) > total.toFixed(0) ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
            $oldTotal.attr('data-oldtotalperservice', priceOld.toFixed(0) > total.toFixed(0) ? priceOld : '');

            const $total = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-totalperservice]') : $unit.find('.price');
            $total.text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
            $total.attr('data-totalperservice', total);
            $total.attr('data-currency', currencySymbol);
            $total.attr('data-bookingStatus', bookingStatus);
            $total.attr('data-pricelistid', pricelistid);

            $totalPerServiceBlock.append($totalPerServiceHtml[0].outerHTML);
        });

        let minp = null;
        $totalPerServiceBlock.find("[data-order]").each((index, elem) => {
            let p = +$(elem).attr('data-order');
            if (minp === null || p < minp) {
                minp = p;
            }
        });

        $totalPerServiceBlock.find(".order-" + minp).find('[type="radio"]').click();
        $totalPerServiceBlock.find(".order-" + minp).addClass('border-0');
    },
    calculationDone(response, params) {

        $('.unit[data-dynamicunitid]').remove();

        if(response.status) {
            const data = response.data || [];

            if (this.params.isTravelgate) {
                $(".units-no-result-msg").addClass('d-none');
            }

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                let $unit = $('.unit[data-unitid=' + unitId + ']');
                let $unitModal = $("#unitModal-" + unitId);
                if ( ! $unit.length )
                {
                    if (unitId.indexOf('_') === -1) return;

                    const _unitId = unitId.replace(/_\d+$/, "");
                    const $_unitId = $($('.unit[data-unitid=' + _unitId + ']').prop('outerHTML'));

                    $_unitId.attr('data-dynamicunitid', unitId);
                    $(".units").append($_unitId);

                    $unit = $('.unit[data-dynamicunitid=' + unitId + ']');
                    $unitModal = $("#unitModal-" + _unitId);
                }

                let isBookable = false;

                const unitServiceCount = unitData.services ? Object.values(unitData.services).length : 0;
                $unit.find('.rate-container').length && $unit.find('.rate-container').toggleClass('d-none', unitServiceCount > 1);

                if(unitData.services && details.isBookablePerService(unitData.services)) {
                    isBookable = true;
                    const total = details.getMinPricePerService(unitData.services);
                    detailsPackage.preparePriceAndBooking(unitId, $unit, unitData, params);
                    $unit.prop('style', 'order: ' + parseInt(total));

                    $unit.find('.price-from-label').addClass('d-none');
                    $unit.find('.total-label').removeClass('d-none');
                    $unit.find('.price-wrapper').removeClass('d-none');
                    $unit.find('.service-label').removeClass('d-none');
                } else {
                    $unit.prop('style', 'order: 100000;');
                    $unit.find('.total-label').addClass('d-none');
                    $unit.find('.price-wrapper').addClass('d-none');
                    $unit.find('.service-label').addClass('d-none');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-message').text(error);

                $unit.find('.price-from-label').addClass('d-none');
                //$unit.find('.total-label').removeClass('d-none');
                
                $unit.find('.block-totals-per-service').toggleClass('d-none', ! isBookable || unitServiceCount < 2);
                $unit.find('.fast-and-secure-label').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                if (this.params.isTravelgate) {
                    $unit.toggleClass('d-none', ! isBookable);
                    $unit.find('[data-unitName]').text(unitData.unitName);
                    $unitModal.find('.modal-unit-name').html(unitData.unitName);
                    let totalGuests = +params.guests.split(',')[0] + +params.guests.split(',')[1];
                    $unit.find('.unit-no-guests').text(totalGuests);
                }

            });

            if (this.params.isTravelgate && ! $(".units .unit").not('.d-none').length) {
                $(".units-no-result-msg").removeClass('d-none');
            }
        }
    }
};